import {useEffect} from 'react';
import {disablePosterEditorShortcuts, enablePosterEditorShortcuts} from '@PosterWhiteboard/poster/poster-editor-shortcuts';
import {pausePosterOnModalOpen} from '@Components/poster-editor/library/poster-editor-library';
import {useAppSelector} from '@/hooks';
import {isPosterPushModalOpen} from '@Components/modal-container/modal-container-reducer';

export const usePosterPushModalEffects = (): void => {
  const isPosterPushModalOpened = useAppSelector(isPosterPushModalOpen);

  useEffect(() => {
    if (isPosterPushModalOpened) {
      disablePosterEditorShortcuts();
      pausePosterOnModalOpen();
    } else {
      enablePosterEditorShortcuts();
    }
  }, [isPosterPushModalOpened]);
};
